import React from 'react'
import * as Styled from './styled'

export const WizardComment = ({ note }: { note?: string }) => {
  if (!note) return null

  return <Styled.SmallText>{`Note: ${note}`}</Styled.SmallText>
}
